import actions from './actions'

const initialState = {
    token: null,
    intugineTokenFetchedAt: null,
    loggedIn: false,
    username: null,
    email: null,
    profile: {},
    keycloakAccessToken: null,
    keycloakRefreshToken: null,
    keycloakIdToken: null,
    keycloakAccessTokenExpiresAt: null,
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actions.LOGIN:
            return ({
                ...state,
                username: action.payload.username,
                token: action.payload.token,
                email: action.payload.email,
                profile: action.payload.profile || {},
                loggedIn: true,
                ...(action.payload.token != null && {
                    intugineTokenFetchedAt: Date.now(),
                }),
            })
        case actions.UPDATE_KEYCLOAK_TOKENS: {
            const nextState = {
                ...state,
                keycloakAccessToken:
                    action.payload.accessToken ?? state.keycloakAccessToken,
                keycloakRefreshToken:
                    action.payload.refreshToken ?? state.keycloakRefreshToken,
            };

            if (action.payload.expiresIn != null) {
                nextState.keycloakAccessTokenExpiresAt =
                    Math.floor(Date.now() / 1000) + action.payload.expiresIn;
            }

            if (action.payload.idToken !== undefined) {
                nextState.keycloakIdToken = action.payload.idToken;
            }

            if (action.payload.profile) {
                nextState.profile = action.payload.profile;
                nextState.email = action.payload.email ?? state.email;
                nextState.username = action.payload.username ?? state.username;
            }

            return nextState;
        }
        case actions.LOGOUT:
            return ({
                ...state,
                username: null,
                email: null,
                token: null,
                intugineTokenFetchedAt: null,
                profile: {},
                loggedIn: false,
                keycloakAccessToken: null,
                keycloakRefreshToken: null,
                keycloakIdToken: null,
                keycloakAccessTokenExpiresAt: null,
            })
        default: 
            return state
    }
}

export default reducer;
